<template>
  <div class="chart-settings">
    <label v-for="field in FIELDS" :key="field.key" class="setting" :title="field.hint">
      <span class="setting__label">{{ field.label }}</span>
      <input
        type="number"
        class="gm-input setting__input"
        :min="field.min"
        :max="field.max"
        :step="field.step"
        :value="modelValue[field.key]"
        @input="update(field, $event.target.value)"
      />
    </label>

    <button type="button" class="gm-btn gm-btn--sm gm-btn--ghost" @click="$emit('reset')">
      Reset
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Object, required: true },
});

const emit = defineEmits(['update:modelValue', 'reset']);

const FIELDS = [
  { key: 'maxStat', label: 'Max stat', min: 10, max: 200, step: 10, hint: 'Highest stat value plotted on the X axis' },
  { key: 'statStep', label: 'Step', min: 1, max: 20, step: 1, hint: 'Distance between plotted anchor points' },
  { key: 'diceMin', label: 'Dice min', min: 0, max: 2, step: 0.1, hint: 'Lowest dice multiplier — the bottom of the corridor' },
  { key: 'diceMax', label: 'Dice max', min: 1, max: 3, step: 0.1, hint: 'Highest dice multiplier — the top of the corridor' },
];

// An empty or half-typed field would push NaN through the formula and blank the
// chart, so a value only reaches the config once it parses and fits its bounds.
function update(field, raw) {
  const value = Number(raw);
  if (!Number.isFinite(value) || value < field.min || value > field.max) return;
  emit('update:modelValue', { ...props.modelValue, [field.key]: value });
}
</script>

<style scoped>
.chart-settings {
  display: flex;
  align-items: center;
  gap: var(--gm-gap-sm);
  flex-wrap: wrap;
}

.setting {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.setting__label {
  font-family: var(--gm-font-display);
  font-size: 0.55rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--gm-text-muted);
}

.setting__input {
  width: 4.25rem;
  padding: 0.2rem 0.35rem;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
}
</style>
